import { useContext } from 'react';
import { Row } from 'react-bootstrap';
import { PermintaanProduksiContext } from '../../Context';
import { TableMP } from './TableMP';

export const ContainerMP = ({ showHistory }) => {
  const { dataMP } = useContext(PermintaanProduksiContext);

  return (
    <Row>
      <TableMP
        jobOrder
        showTotalPrice
        title="List Machine Process Dari Job Order"
        data={dataMP.jobOrder}
      />
      <TableMP
        showInputRow
        showTotalPrice
        title="List Permintaan Machine Process"
        data={dataMP.permintaan}
      />
      {showHistory && (
        <TableMP
          readOnly
          title="History Permintaan Machine Process"
          data={dataMP.history}
        />
      )}
    </Row>
  );
};
